// GIGI PIP
export const CART_TOTAL_SELECTOR =
  "cart-drawer > div:nth-child(2) .h-stack.gap-4.justify-between";
